import React from "react";
import BannerSection from "../component/section/banner";
import MemberSection from "../component/section/member";
import AboutSection from "../component/section/about";
import StorySection from "../component/section/storysection";
import WorkSection from "../component/section/work";
import MemberTwoSection from "../component/section/memberTwo";
import GroupSection from "../component/section/group";
import ClientSection from "../component/section/clints";
import AppsSection from "../component/section/apps";
import WhyBATSection from "../component/section/whyBAT";
import HowWorksSection from "../component/section/howWorks";

const HomePages = () => {
  return (
    <div>
      <BannerSection />
      <MemberSection />
      <AboutSection />
      <HowWorksSection />
      <WhyBATSection />
      <WorkSection />
      {/* <StorySection />
        <MemberTwoSection />
        <GroupSection />
        <ClientSection />
        <AppsSection /> */}
    </div>
  );
};

export default HomePages;
